/**
 * Unwraps NestJS API responses that may be shaped as:
 * { success: true, data: T }
 * or accidentally double-wrapped.
 */
export function unwrapApiResponse<T = unknown>(res: unknown): T | null {
  if (res == null) return null
  if (typeof res !== 'object') return res as T

  const r = res as Record<string, unknown>

  if ('success' in r && 'data' in r && r.data !== undefined) {
    const inner = r.data as Record<string, unknown>
    if (
      inner &&
      typeof inner === 'object' &&
      'success' in inner &&
      'data' in inner &&
      (inner as Record<string, unknown>).data !== undefined
    ) {
      return (inner as { data: T }).data
    }
    return r.data as T
  }

  return res as T
}
